import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import isArray from 'lodash-es/isArray';

export const COMPANY_NAME = 'Digistrique Solutions Private Limited';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeWithCustomizer(objValue: any, srcValue: any) {
  if (isArray(objValue)) {
    return srcValue;
  }
}

/**
 * Converts a string to title case.
 * Steps:
 * 1. Converts the string to lowercase.
 * 2. Replaces underscores with spaces.
 * 3. Capitalizes the first letter of each word.
 *
 * @param str - The input string to be converted.
 * @returns The converted string in title case.
 */
export function convertToTitleCase(str: string): string {
  return str
    .toLowerCase() // Step 1: Convert to lowercase
    .replace(/_/g, ' ') // Step 2: Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Step 3: Capitalize the first letter of each word
}

export const underscoreToSpace = (str: string | null) => {
  if (!str) return '';
  return str.replace(/_/g, ' ');
};

/**
 * Converts a given value to a safe number. If the conversion
 * results in NaN, a fallback value is returned instead.
 *
 * @param value - The value to be converted to a number.
 * @param fallback - The fallback number to return if conversion fails (default is 0).
 * @returns The converted number or the fallback value if the conversion is NaN.
 */
export const toSafeNumber = (value: unknown, fallback = 0): number => {
  const num = Number(value);
  return isNaN(num) ? fallback : num;
};
